export default "__VITE_ASSET__gvP6Au4O__"